import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite, TweenLite} from "gsap";
import {FruitsGameConfig} from "../../FruitsGameConfig";
import {IWinLineConfig, WinLine, WinText} from "../WinLines/WinLine";
import {FruitsHelper} from "../../utils/FruitsHelper";


/**
 * Created by Alican Köker on 2018-06-29.
 */

export class FruitsIndividiualWPBetlineView extends BaseView {

    private _layer:ScalableLayer;
    private _lineContainer:PIXI.Container;
    private _lineColorList:number[] = [
        0xff3399,
        0xff3333,
        0xfd8c19,
        0xccffcc,
        0xffff00,
        0x00cc00,
        0x00cc66,
        0x00ccff,
        0x227bff,
        0xcc33ff,
    ];

    private _lineConfig:IWinLineConfig = {
        lineThickness : 14,
        baseColor : 0x46D260,
        dynamicColor : true,
        dynamicColors : this._lineColorList,
    };

    private _orientation:string = Orientation.LANDSCAPE;

    constructor() {
        super();

        this._layer = StageManager.getLayer(FruitsGameConfig.instance.LAYERS.BET_LINES.name);
        this._lineContainer = new PIXI.Container();
        this._layer.addChild(this._lineContainer);
        this.initContainer();
    }

    protected onResize(resizeData:IResizeData):void {

        if(resizeData.orientation === Orientation.PORTRAIT) {
            this._orientation = Orientation.PORTRAIT;
        } else {
            this._orientation = Orientation.LANDSCAPE;
        }

        this._lineContainer.removeChildren();
    }

    public animateWinningLine(winData:IBetLineWinData, index:number):TimelineLite {

        this.initContainer();

        const tl:TimelineLite = new TimelineLite();

        this._lineContainer.visible = false;

        let line = new WinLine(this._orientation);
        this._lineContainer.addChild(line);

        const winText = new WinText(winData);
        let pos:number[] = FruitsHelper.getSymbolPosition(2, winData.betLine[2], this._orientation);
        winText.position.set(pos[0], pos[1]);
        this._lineContainer.addChild(winText);

        if(winData) {
            tl.add(() => line.strokeWinningline(winData.betLine, index, this._lineConfig));

            tl.add(() => this._lineContainer.visible = true);
        }

        return tl;
    }

    public fadeOutLines():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(TweenLite.to(this._lineContainer, 0.4, {alpha: 0}));
        return tl;
    }

    public initContainer():void {
        this._lineContainer.removeChildren();
        this._lineContainer.alpha = 1;
    }

}